import * as React from 'react';
import clsx from 'clsx';
import { makeStyles, useMediaQuery } from '@material-ui/core';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { ElementDimensions } from '../../styles/ElementDimensions';
import { CheckStateContext } from '../../providers/CheckStateContextProvider';
import CreditCardButton from '../../images/creditcardbutton.png'
import GPayButton from '../../images/gpaybutton.png'
import ApplePayButton from '../../images/applepaybutton.png'
import RoomChargeButton from '../../images/roomchargebutton.png'
import DemoRoomChargeDialog from './DemoRoomChargeDialog';

const useStyles = makeStyles({
    button: {
        marginBottom: '30px',
    },
    root: {
        marginTop: '30px',
        textAlign: 'center',
        height: 'calc(100vh - ' + (73 + ElementDimensions.appBarHeight + ElementDimensions.stepperHeight + ElementDimensions.footerBarHeightPaymentScreen) + 'px)',
    },
    rootLandscape: {
        textAlign: 'center',
        height: '150%',
    },
});

export type DemoPaymentButtonClickHandler = (event: React.MouseEvent<HTMLElement>) => any;

export interface DemoPaymentProps {
    onClickHandler: DemoPaymentButtonClickHandler;
}

export default function DemoPayment(props: DemoPaymentProps) {
    const {onClickHandler} = props;
    const isPortrait = true;
    const [roomChargeDialogOpen, setRoomChargeDialogOpen] = React.useState<boolean>(false);
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    const handleButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        onClickHandler(event);
    }

    const handleRoomChargeClick = (event: React.MouseEvent<HTMLElement>) => {
        setRoomChargeDialogOpen(true)
    }

    const handleRoomChargeCloseButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        setRoomChargeDialogOpen(false);
    }

    const handleRoomChargeCompleteClick = (event: React.MouseEvent<HTMLElement>) => {
        setRoomChargeDialogOpen(false);
        onClickHandler(event);
    }

    return (
        <div className={clsx({
            [classes.root]: isPortrait,
            [classes.rootLandscape]: !isPortrait,
        })}>
            <img src={CreditCardButton} className={classes.button} onClick={handleButtonClick} />
            <img src={ApplePayButton} className={classes.button} onClick={handleButtonClick} />
            <img src={GPayButton} className={classes.button} onClick={handleButtonClick} />
            <img src={RoomChargeButton} className={classes.button} onClick={handleRoomChargeClick} />

            <DemoRoomChargeDialog 
                open={roomChargeDialogOpen}
                onCloseHandler={handleRoomChargeCloseButtonClick}
                onCompleteHandler={handleRoomChargeCompleteClick} />

        </div>
        
    );
}